/*
Grommets

  --liner <bool> | checkbox
*/

import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  {
    text: 'Liner',
    value: 'liner',
    sortable: true,
    sort: 'boolean',
    render: 'boolean'
  }
]
